import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import {Col, Row} from 'reactstrap';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { changePassword } from '../../../store/actions/user';
import { ChangePasswordSchema } from '../../../helpers/schemas';
import { Messages } from '../../layout/Messages/Messages';
import * as Notifications from '../../../config/notifications';
import {CustomField} from "./CustomField";
import { PageSurface } from '../../layout/Workspace';

const ChangePasswordComponent = (props) => {
    const { changePassword } = props;

    return (
      <PageSurface
        className="profile-panel profile-password-panel"
        header={<h2 className="profile-panel-title"><FormattedMessage id="components.pages.profile.edit_profile.password_title"/></h2>}
      >
          <Formik
            initialValues={{ old_password: '', new_password: '', new_password_confirmation: '' }}
            validationSchema={ ChangePasswordSchema }
            enableReinitialize={ true }
            onSubmit={ (values, {setSubmitting, resetForm}) => {
              const { old_password, new_password, new_password_confirmation } = values;
              changePassword(old_password, new_password, new_password_confirmation);
              resetForm({
                old_password: '',
                new_password: '',
                new_password_confirmation: ''
              });
              setSubmitting(false);
            }}
          >
            {formikProps => (
              <Fragment>
                <Messages
                  notificationId={ Notifications.NOTIFICATION_CHANGE_PASSWORD }
                  formikProps={ formikProps }
                >
                  <ErrorMessage name="old_password" component="div" data-testid="errors-old_password" className="field-error"/>
                  <ErrorMessage name="new_password" component="div" data-testid="errors-new_password" className="field-error"/>
                  <ErrorMessage name="new_password_confirmation" component="div" data-testid="errors-new_password_confirmation" className="field-error"/>
                </Messages>
                <Form>
                <Row>
                    <Col lg="12">
                      <CustomField
                        label="components.pages.profile.edit_profile.old_password"
                        name="old_password"
                        fieldName="old_password"
                        type="password"
                        value={ formikProps.values.old_password }
                        onChange={ event => { formikProps.setFieldValue("old_password", event.target.value) } }
                        handleBlur={ formikProps.handleBlur }
                        key={ formikProps.isSubmitting }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <CustomField
                        label="components.pages.profile.edit_profile.new_password"
                        name="new_password"
                        fieldName="new_password"
                        type="password"
                        value={ formikProps.values.new_password }
                        onChange={ event => { formikProps.setFieldValue("new_password", event.target.value) } }
                        handleBlur={ formikProps.handleBlur }
                        key={ formikProps.isSubmitting }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <CustomField
                        label="components.pages.profile.edit_profile.new_password_confirmation"
                        name="new_password_confirmation"
                        fieldName="new_password_confirmation"
                        type="password"
                        value={ formikProps.values.new_password_confirmation }
                        onChange={ event => { formikProps.setFieldValue("new_password_confirmation", event.target.value) } }
                        handleBlur={ formikProps.handleBlur }
                        key={ formikProps.isSubmitting }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <FormattedMessage id="components.pages.profile.edit_profile.change_password_btn">
                      {
                        valueBtn => <Field className="my-4 btn btn-primary mx-auto" type="submit" value={valueBtn}/>
                      }
                    </FormattedMessage>
                  </Row>
                </Form>
              </Fragment>
            )}
          </Formik>
      </PageSurface>
    );
}


const mapStateToProps = state => ({
  profile: state.user.profile,
});

const mapActionsToProps = {
  changePassword
};

const ChangePassword = connect(mapStateToProps, mapActionsToProps)(ChangePasswordComponent);
export { ChangePassword, ChangePasswordComponent };
